module.exports = __webpack_public_path__ + "static/img/law.90df9a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/law.jpg
// module id = CijW
// module chunks = 1